import { render, staticRenderFns } from "./PoiList.vue?vue&type=template&id=09d27829&"
import script from "./PoiList.vue?vue&type=script&lang=js&"
export * from "./PoiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports